import defaultUser from '../utils/default-user';
import a180344_yahoo_com from '../utils/a180344_yahoo_com-user';

export async function signIn(email, password) {
  try {
      // Send request
      console.log(email, password);

      if (email === 'a180344@yahoo.com' && password === 'panama')
      {
          return {
              isOk: true,
              data: a180344_yahoo_com
          };
      }

      return {
          isOk: false,
          message: "Authentication failed"
      };

    //return {
    //  isOk: true,
    //  data: defaultUser
    //};
  }
  catch {
    return {
      isOk: false,
      message: "Authentication failed"
    };
  }
}

export async function getUser() {
  try {
    // Send request
      return {
          isOk: false,
          message: "Authentication failed"
      };

    //return {
    //  isOk: true,
    //  data: defaultUser
    //};
  }
  catch {
    return {
      isOk: false
    };
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
